<template>
  <div>
    <portal to="sidebar-menu">
      <nav-list :items="navigationItems"></nav-list>
    </portal>

    <router-view></router-view>
  </div>
</template>
<script>
  import { getRouteName, routeTypes } from 'src/config/routeTypes'
  import entities from 'src/config/entities'

  export default {
    data () {
      return {
        navigationItems: [
          {
            type: 'group',
            name: this.$t('generic.jobReports')
          },
          {
            routeName: getRouteName(routeTypes.LIST, entities.JOB_REPORT),
            name: this.$t('reports.overview')
          },
          {
            routeName: getRouteName(routeTypes.LIST, entities.JOB_BOARD_REPORT),
            name: this.$t('jobBoard.list.title')
          },
          {
            type: 'group',
            name: this.$t('generic.ecommerceReports')
          },
          {
            routeName: getRouteName(routeTypes.LIST, entities.ECOMMERCE_REPORT),
            name: this.$t('reports.overview')
          },
          {
            routeName: getRouteName(routeTypes.LIST, entities.ECOMMERCE_JOB_BOARD_REPORT),
            name: this.$t('jobBoard.list.title')
          },
          {
            type: 'group',
            name: this.$t('generic.clientReports')
          },
          {
            routeName: getRouteName(routeTypes.LIST, entities.CLIENT_REPORT),
            name: this.$t('generic.clients')
          },
          {
            type: 'group',
            name: this.$t('generic.candidateReports')
          },
          {
            routeName: getRouteName(routeTypes.LIST, entities.CANDIDATE_REPORT),
            name: this.$t('generic.candidates')
          },
          {
            type: 'group',
            name: this.$t('generic.creditReports')
          },
          {
            routeName: getRouteName(routeTypes.LIST, entities.CREDIT_REPORT),
            name: this.$t('generic.credits')
          },
          {
            routeName: getRouteName(routeTypes.LIST, entities.CONTRACT_REPORT),
            name: this.$t('generic.contracts')
          },
        ]
      }
    }
  }
</script>
<style>
</style>
